import { apiGet } from './client';

function buildQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function getPublicTeamRoster({ query, limit = 24, offset = 0 } = {}) {
  return apiGet(`/selection/teams${buildQuery({ query, limit, offset })}`);
}
